import React, { memo } from 'react';

import Analysis from './analysis';
import Overview from './overview';
import AllStoresStatus from './stores';
import './styles.scss';
import Trends from './trend';

const Dashboard = () => (
  <div className="ant-pro-grid-content main-content">
    <Overview />
    <Trends />
    <Analysis />
    <AllStoresStatus />
  </div>
);

export default memo(Dashboard);
